import { AxiosError } from 'axios';
import backendClient from '@services/api/backendClient';

export const TICKETMASTER_TRANSFER_MODE_TEST = 'test';
export const TICKETMASTER_TRANSFER_MODE_FULL = 'full';

export type TicketmasterTransferRunMode =
  | typeof TICKETMASTER_TRANSFER_MODE_TEST
  | typeof TICKETMASTER_TRANSFER_MODE_FULL;

export async function runTicketmasterTransfer(
  mode: TicketmasterTransferRunMode
): Promise<void> {
  await backendClient.post('/backstage/ticketmaster-transfer/run', { mode });
}

export function getTicketmasterTransferErrorMessage(error: unknown): string {
  const axiosError = error as AxiosError<{ message?: string }>;
  return (
    axiosError.response?.data?.message ??
    axiosError.message ??
    'Ticketmaster transfer request failed'
  );
}
